/* eslint-disable max-len */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const CloseCircleIcon = (props: IconProps) => (
  <Icon viewBox='0 0 12 12' { ...props }>
    <path
      d='M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.42474 3.57487C8.20694 3.35708 7.85383 3.35708 7.63604 3.57487L5.99961 5.2113L4.36318 3.57487C4.14538 3.35708 3.79227 3.35708 3.57448 3.57487C3.35668 3.79267 3.35668 4.14578 3.57448 4.36357L5.21091 6L3.57448 7.63643C3.35668 7.85423 3.35668 8.20734 3.57448 8.42513C3.79227 8.64293 4.14538 8.64293 4.36318 8.42513L5.99961 6.7887L7.63604 8.42513C7.85383 8.64293 8.20694 8.64293 8.42474 8.42513C8.64253 8.20734 8.64253 7.85423 8.42474 7.63643L6.78831 6L8.42474 4.36357C8.64253 4.14578 8.64253 3.79267 8.42474 3.57487Z'
      fill='white'
    />
  </Icon>
);
